module.exports = __webpack_public_path__ + "static/media/12.9036a7f2.jpg";